export default {
  teal: '#2BD3CA',
  purple: '#3F2A56',
};